import script from "./DiscogsMain.vue?vue&type=script&setup=true&lang=js"
export * from "./DiscogsMain.vue?vue&type=script&setup=true&lang=js"

import "./DiscogsMain.vue?vue&type=style&index=0&id=d62313c4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d62313c4"]])

export default __exports__